import * as actionTypes from './actionTypes';

export const fetchGroupPostsList = (GroupId, Page, PageSize, RoomId, Tag) => {
  return {
    type: actionTypes.FETCH_GROUP_POSTS_LIST,
    GroupId,
    Page,
    PageSize,
    RoomId,
    Tag,
  };
};

export const fetchGroupPostsListStart = () => {
  return {
    type: actionTypes.FETCH_GROUP_POSTS_LIST_START,
  };
};

export const fetchGroupPostsListSuccess = (GroupId, Posts, PostCount, PostLimit, Page, Tag) => {
  return {
    type: actionTypes.FETCH_GROUP_POSTS_LIST_SUCCESS,
    GroupId,
    Posts,
    PostCount,
    PostLimit,
    Page,
    Tag,
  };
};

export const fetchGroupPostsListFailed = (error) => {
  return {
    type: actionTypes.FETCH_GROUP_POSTS_LIST_FAILED,
    error,
  };
};
